(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-carousel-autoplay"] && !Shopify.designMode) return;
  try {
    (() => {
    const mobileDevice = window.matchMedia('(max-width: 749px)');

    const pauseCarousel = (carousel) => {
      if (!mobileDevice.matches || carousel.slider?.dataset.autoplay !== 'true') return;

      const autoplayButton = carousel.querySelector('.slideshow__autoplay');
      if (!autoplayButton) return;

      carousel.autoplayButtonIsSetToPlay = false;
      carousel.togglePlayButtonState(true);
      carousel.pause();
    };

    const pauseCarousels = (root = document) => {
      if (root.matches?.('slideshow-component')) pauseCarousel(root);
      root.querySelectorAll?.('slideshow-component').forEach(pauseCarousel);
    };

    const initialize = () => {
      customElements.whenDefined('slideshow-component').then(() => pauseCarousels());
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      customElements.whenDefined('slideshow-component').then(() => pauseCarousels(event.target));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
